import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "bg-gray-900 text-white min-h-screen",
  style: {"background-image":"url('https://wallpapercave.com/wp/GYYs5kF.jpg')","background-size":"cover","background-position":"center"}
}
const _hoisted_2 = { class: "bg-gray-800 p-4 shadow-lg" }
const _hoisted_3 = { class: "max-w-7xl mx-auto flex justify-between items-center" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "text-lg font-bold" }, "DK Studio", -1)
const _hoisted_5 = { class: "space-x-4 flex" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("nav", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_router_link, {
            to: "/",
            class: "hover:text-blue-500 transition duration-300"
          }, {
            default: _withCtx(() => [
              _createTextVNode("Home")
            ]),
            _: 1
          }),
          _createVNode(_component_router_link, {
            to: "/store",
            class: "hover:text-blue-500 transition duration-300"
          }, {
            default: _withCtx(() => [
              _createTextVNode("Store")
            ]),
            _: 1
          }),
          _createVNode(_component_router_link, {
            to: "/projects",
            class: "hover:text-blue-500 transition duration-300"
          }, {
            default: _withCtx(() => [
              _createTextVNode("Projects")
            ]),
            _: 1
          }),
          _createVNode(_component_router_link, {
            to: "/contact",
            class: "hover:text-blue-500 transition duration-300"
          }, {
            default: _withCtx(() => [
              _createTextVNode("Contact")
            ]),
            _: 1
          }),
          _createVNode(_component_router_link, {
            to: "/about",
            class: "hover:text-blue-500 transition duration-300"
          }, {
            default: _withCtx(() => [
              _createTextVNode("About")
            ]),
            _: 1
          })
        ])
      ])
    ]),
    _createVNode(_component_router_view)
  ]))
}